<select class="form-control dropdown-toggle header-language-selector" [(ngModel)]='selectedLanguage' (change)="languageChange($event)">
  @for (language of languageList; track language) {
    <option  [value]="language.languageCode">{{language.languageName}}</option>
  }
</select>